/* 
 *  Copyright (c) McAfee.  All Rights Reserved.
 *
 * McUtil accessor (read-only)
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack
 
import { logNormal, logInformation, logWarning, logError, logDebug, logConsole, logRawTrack, logTransports, logAutomationError } from "./bootstrap_web_ext";
import { ModuleManager , globalEngine} from "./Init";
import {getPluginFactory} from "./bootstrap_web_ext";

// #ENDIF WebPack
function CreateMcUtilHelper()
{
    var mcutil =
    {
        "_logError" : function(msg) {
            logError('mcUtil: ' + msg);
        },
        "_logInfo" : function(msg) {
            logInformation('mcUtil: ' + msg);
        },
        "_getPlugin": function ()
        {
            if (!this._plugin)
            {
                var data_collector = ModuleManager.getSingleton("data_collector");
                var sdkVer = data_collector.get("Analytics.SDK.Version");
                if (sdkVer.match('^2\.[0-5]'))
                {
                    this._logInfo('This SDK does not support mcUtil plugin. sdkVer(' + sdkVer + ')');
                    return null;
                }
                this._plugin = getPluginFactory().Create("mcUtil");
            }
            return this._plugin;
        },
        "_plugin": null,
        "_hardwareId": null,
        "_softwareId": null,
        "storeHardwareAndSoftwareId" : function (override)
        {
            try
            {
                this._logInfo('storeHardwareAndSoftwareId - start');
                if(!this._getPlugin()){
                    return;
                }

                var storeValue = override;
                if(!override) {
                    var data_collector = ModuleManager.getSingleton("data_collector");
                    var value = data_collector.get("WSS.Hardware.ID");
                    storeValue = (value ==="[ruleMismatch]") ? true : false;
                    this._logInfo('value: ' + value );
                    this._logInfo('storeValue: ' + storeValue );
                }

                if(!storeValue) {
                    this._logInfo('Not going to storeValue');
                    return;
                }

                this._invokeGetMachineId();

                if( !this._softwareId) {
                    this._logError('storeHardwareAndSoftwareId: No value for softwareId');
                    return;
                }
                
                if(!this._hardwareId ) {
                    this._logError('storeHardwareAndSoftwareId: No value for hardwareId' );
                    return;
                }

                var registry = ModuleManager.getSingleton("registry");
                registry.openKey("HKLM\\SOFTWARE\\McAfee\\McClientAnalytics", true);
                registry.setValue("WSS_HardwareId", this._hardwareId);
                registry.setValue("WSS_SoftwareId", this._softwareId);
            }
            catch(e)
            {
                this._logError('storeHardwareAndSoftwareId: ' + e.message);
            }

        },
        "getHardwareId": function()
        {
            if(!this._hardwareId) {
                this._getMachineId();
            }

            return this._hardwareId;
        },
        "getSoftwareId": function()
        {
            if(!this._softwareId) {
                this._getMachineId();
            }

            return this._softwareId;
        },
        "_invokeGetMachineId": function()
        {
            var plugin = this._getPlugin();
            if(!plugin)
            {
                logError('No mcUtil plugin created');
                return false;
            }

            var machineInfo = plugin.GetMachineId();
            var machineInfoObj = JSON.parse(machineInfo);

            this._hardwareId = machineInfoObj.hardwareId;
            this._softwareId = machineInfoObj.softwareId;

            return true;
        }
    };
    return mcutil;
}

// register with the factory function with ModuleManager
ModuleManager.registerFactory("mcutil", CreateMcUtilHelper);
//export  {CreateMcUtilHelper};
//globalEngine.FactoryMap["mcutil"] =  CreateMcUtilHelper;


